export default __webpack_public_path__ + "static/media/abrePromovidos.f7d6662c.jpg";